export default __webpack_public_path__ + "static/media/showerbaseafter.9d4a58a0.jpg";